(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const videos = new Set();
  const update = video => {
    if (!video.dataset.loopVisible || reducedMotion.matches || document.hidden) {
      video.pause();
      return;
    }
    if (!video.getAttribute('src') && video.dataset.loopSrc) {
      video.src = video.dataset.loopSrc;
      video.load();
    }
    video.autoplay = true;
    video.play().catch(() => {});
  };
  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(entries => entries.forEach(entry => {
      entry.target.dataset.loopVisible = entry.isIntersecting ? 'true' : '';
      update(entry.target);
    }), {rootMargin: '200px 0px'})
    : null;
  const init = (root = document) => {
    root.querySelectorAll('video[data-wohlora-loop]').forEach(video => {
      if (videos.has(video)) return;
      videos.add(video);
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.playsInline = true;
      video.controls = false;
      if (observer) observer.observe(video);
      else {
        video.dataset.loopVisible = 'true';
        update(video);
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('visibilitychange', () => videos.forEach(update));
  reducedMotion.addEventListener('change', () => videos.forEach(update));
})();
